import { 
    ADD_FILE, UPDATE_FILE, UPDATE_FILE_FROM_ID, 
    REMOVE_FILE, PURGE_FILES, UPDATE_COMPRESS, 
    UPLOAD_STATUS_WAITING_UPLOAD, UPLOAD_STATUS_PENDING_UPLOAD
} from "../actions/file"

const post = (state, action) => {

    if (!state) {
        state = { files: [] };
        const files = window.sessionStorage.getItem('files');
        if (files) state.files = JSON.parse(files);
        state.files = state.files.reduce((files, file) => {
            // If reload remove UPLOAD_STATUS_PENDING_UPLOAD and UPLOAD_STATUS_WAITING_UPLOAD as file object is not saved
            if([UPLOAD_STATUS_PENDING_UPLOAD, UPLOAD_STATUS_WAITING_UPLOAD].includes(file.uploadStatus)) return files;
            files.push(file);
            return files;
        }, [])
        window.sessionStorage.setItem('files', JSON.stringify(state.files));
    }

    switch (action.type) {
        case ADD_FILE:
            const filesAddArray = state.files;
            action.files.forEach(file => {
                filesAddArray.push(file)
            })
            window.sessionStorage.setItem('files', JSON.stringify(filesAddArray));
            return Object.assign({}, state, { files: filesAddArray })
        case UPDATE_FILE:
            const filesUpdateArray = [];
            state.files.forEach((file, index) => {
                if (index === action.index){
                    if(action.mode === "removed") {
                        delete file.convertTo;
                    } else {
                        file.convertTo = action.mode;
                    }
                }
                filesUpdateArray.push(file)
            })
            window.sessionStorage.setItem('files', JSON.stringify(filesUpdateArray));
            return Object.assign({}, state, { files: filesUpdateArray })
        case UPDATE_FILE_FROM_ID:
            const file = state.files.find(file => file.id === action.file.id);
            if(!file) return;
            Object.assign(file, action.file);
            window.sessionStorage.setItem('files', JSON.stringify(state.files));
            return Object.assign({}, {files: state.files})
        case UPDATE_COMPRESS:
            const filesCompressUpdateArray = [];
            state.files.forEach((file) => {
                if(file.id === action.id){
                    filesCompressUpdateArray.push(action.file)
                } else {
                    filesCompressUpdateArray.push(file)
                }
            })
            window.sessionStorage.setItem('files', JSON.stringify(filesCompressUpdateArray));
            return Object.assign({}, state, { files: filesCompressUpdateArray })
        case REMOVE_FILE:
            state.files = state.files.filter(file => file.id !== action.id);
            window.sessionStorage.setItem('files', JSON.stringify(state.files));
            return Object.assign({}, state, { files: state.files })
        case PURGE_FILES:
            window.sessionStorage.removeItem('files');
            return Object.assign({}, state, { files: [] })
        default:
            return state;
    }
}

export default post;
